import { render, staticRenderFns } from "./DatasetManager.vue?vue&type=template&id=76f28195&"
import script from "./DatasetManager.vue?vue&type=script&lang=js&"
export * from "./DatasetManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports